import _ from 'lodash';

import { CountEntry } from '../types';

type SubjectAndCourseEnrolmentCounts = {
  [subjectOrCourse: string]: {
    counts: CountEntry[],
    plottableCategories: Set<string>,
  }
}

export const getEmptyCountsBySubjectAndCourse = (courses: {
  subject: string,
  courseId: string
}[]): SubjectAndCourseEnrolmentCounts => courses.reduce((countByCourse, course) => ({
  ...countByCourse,
  [course.subject]: {
    counts: [],
    plottableCategories: new Set<string>(),
  },
  [`${course.subject}#${course.courseId}`]: {
    counts: [],
    plottableCategories: new Set<string>(),
  },
}), {});

export const mergeDuplicateAttributesBySum = (
  object1: { [key: string]: number },
  object2: { [key: string]: number},
): { [key: string]: number } => ({
  ...(object1 || {}),
  ...Object.keys(object2).reduce((acc, key) => ({
    ...acc,
    [key]: (object1[key] || 0) + (object2[key] || 0),
  }), {}),
});

export const getCountAttributes = (
  countEntry: CountEntry,
) => _.omit(countEntry, ['datetime', 'displayDate', 'displayDateWithYear']);

export const getYearAsString = (datetime?: number) => new Date(datetime || '').getFullYear().toString();
